export const formatPudoLockerOpeningHours = (openingHours: string, longTextToNewLine = true) => {
  if (!openingHours) {
    return openingHours;
  }

  // eslint-disable-next-line max-len
  if (
    openingHours ===
    'M: 00:00:00-23:59:59 T: 00:00:00-23:59:59 W: 00:00:00-23:59:59 R: 00:00:00-23:59:59 F: 00:00:00-23:59:59 S: 00:00:00-23:59:59 U: 00:00:00-23:59:59'
  ) {
    return '24/7';
  }

  return (
    (longTextToNewLine ? '\n' : '') +
    openingHours
      .split(', ')
      .filter((exists) => !!exists)
      .map((oh) => oh.trim())
      .join('\n')
  );
};
